import { useMemo, useState } from 'react';
import { CalendarCardSize } from '../enums';
import {
  DEFAULT_CALENDAR_CARD_SIZE,
  DEFAULT_CALENDAR_COL_SPACING,
  DEFAULT_CALENDAR_CARD_SPACING,
  DEFAULT_CALENDAR_CARD_WIDTH,
  CALENDAR_COL_SPACING_MAPPING,
  CALENDAR_CARD_SPACING_MAPPING,
  CALENDAR_CARD_WIDTH_MAPPING,
} from '../constants';

export default function useCalendarCardSize() {
  // 日历卡片的尺寸
  const [cardSize, setCardSize] = useState<CalendarCardSize>(DEFAULT_CALENDAR_CARD_SIZE);

  // 列间距，根据日历卡片尺寸不同，列间距不同
  const colSpacing = useMemo<number>(
    () => CALENDAR_COL_SPACING_MAPPING[cardSize] || DEFAULT_CALENDAR_COL_SPACING,
    [cardSize],
  );

  // 日历卡片间距，根据日历卡片尺寸不同，日历卡片间距不同
  const cardSpacing = useMemo<number>(
    () => CALENDAR_CARD_SPACING_MAPPING[cardSize] || DEFAULT_CALENDAR_CARD_SPACING,
    [cardSize],
  );

  // 日历卡片的宽度，根据日历卡片尺寸不同，日历卡片宽度不同（不针对哪一列，有数据的宽度）
  const cardWidth = useMemo<number>(
    () => CALENDAR_CARD_WIDTH_MAPPING[cardSize] || DEFAULT_CALENDAR_CARD_WIDTH,
    [cardSize],
  );

  // 日历卡片尺寸change回调
  const handleCardSizeChange = (size: CalendarCardSize) => {
    setCardSize(size);
  };

  // 重置日历卡片尺寸为默认尺寸
  const handleResetCardSize = () => {
    setCardSize(DEFAULT_CALENDAR_CARD_SIZE);
  };

  return {
    colSpacing,
    cardSpacing,
    cardWidth,
    onCardSizeChange: handleCardSizeChange,
    resetCardSize: handleResetCardSize,
  };
}
